import { Label } from "shared/ui/label"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "shared/ui/select"
import type { PermitType } from "shared/api/templateService"
import type { Dispatch, SetStateAction } from "react"

interface PermitTypeSelectProps {
  permitData: { permitTypeCode: string; permitType: string }
  setPermitData: Dispatch<SetStateAction<any>>
  permitTypes: PermitType[]
  isPermitTypeLoading?: boolean
  isEditMode?: boolean
  permitTypeError?: string | null
  onPermitTypeChange?: (permit: PermitType | null) => void
}

export const PermitTypeSelect = ({
  permitData,
  setPermitData,
  permitTypes,
  isPermitTypeLoading = false,
  isEditMode = false,
  permitTypeError = null,
  onPermitTypeChange,
}: PermitTypeSelectProps) => {
  const handleChange = (value: string) => {
    if (value === "_default") {
      setPermitData((prev: any) => ({
        ...prev,
        permitType: "",
        permitTypeCode: "",
      }))
      onPermitTypeChange?.(null)
      return
    }
    const selected = permitTypes.find((type) => type.permitCode === value) ?? null
    setPermitData((prev: any) => ({
      ...prev,
      permitType: selected?.permitType ?? "",
      permitTypeCode: selected?.permitCode ?? value,
    }))
    onPermitTypeChange?.(selected)
  }

  return (
    <div className="space-y-2">
      <Label className="text-sm text-gray-600">Permit Type</Label>
      <Select
        value={permitData.permitTypeCode || "_default"}
        onValueChange={handleChange}
        disabled={isEditMode || isPermitTypeLoading || permitTypes.length === 0}
      >
        <SelectTrigger className="bg-gray-50 border-gray-200">
          <SelectValue
            placeholder={
              isPermitTypeLoading
                ? "Loading permit types..."
                : isEditMode
                  ? "Permit type locked"
                  : "Select permit type"
            }
          />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="_default">Select permit type</SelectItem>
          {!isPermitTypeLoading &&
            permitTypes.map((type) => (
              <SelectItem key={type.permitCode ?? type.permitType} value={type.permitCode}>
                {type.permitType}
              </SelectItem>
            ))}
          {permitTypes.length === 0 && !isPermitTypeLoading ? (
            <SelectItem value="_no_types" disabled>
              No permit types available
            </SelectItem>
          ) : null}
        </SelectContent>
      </Select>
      {permitTypeError ? <p className="text-sm text-red-600">{permitTypeError}</p> : null}
    </div>
  )
}
